/**
 * Hero visual — actual screenshot of the live product at app.pipeguide.tech.
 * Wrapped in a window-chrome shell with a soft glow for credibility and depth.
 * Updated to reflect the new app palette (teal primary + mint + signature gold).
 */
const HERO_SCREENSHOT =
    "https://customer-assets.emergentagent.com/job_deal-readiness/artifacts/fopkrxtw_New%20Landing%20page.png";

export default function HeroMock() {
    return (
        <div data-testid="hero-mock" className="relative w-full max-w-5xl mx-auto">
            {/* Soft brand glow */}
            <div
                className="absolute -inset-x-10 -inset-y-6 bg-brand-primary/20 blur-3xl rounded-full"
                aria-hidden
            />

            <div className="relative rounded-2xl border border-zinc-200 bg-white shadow-[0_30px_80px_-20px_rgba(14,78,90,0.35)] overflow-hidden">
                {/* Window chrome */}
                <div className="flex items-center justify-between px-4 py-2.5 border-b border-zinc-200 bg-zinc-50">
                    <div className="flex items-center gap-1.5">
                        <span className="h-2.5 w-2.5 rounded-full bg-zinc-300" />
                        <span className="h-2.5 w-2.5 rounded-full bg-zinc-300" />
                        <span className="h-2.5 w-2.5 rounded-full bg-zinc-300" />
                    </div>
                    <div className="text-[11px] font-mono-pg text-zinc-500">
                        app.pipeguide.tech
                    </div>
                    <div className="flex items-center gap-1.5 text-[11px] font-medium text-emerald-600">
                        <span className="h-1.5 w-1.5 rounded-full bg-emerald-500 live-dot" />
                        Live
                    </div>
                </div>

                {/* Screenshot body */}
                <img
                    src={HERO_SCREENSHOT}
                    alt="PipeGuide — the real-time sales qualification assistant. Live scoring and voice analysis dashboard."
                    loading="eager"
                    width={1920}
                    height={1080}
                    className="w-full h-auto block"
                />
            </div>
        </div>
    );
}
